import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import Logger from "@cappelendamm/logger";
export const getSubscriptionConcept = (subscription) => {
    const concept = getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.CONCEPT);
    const conceptItem = concept?.items?.[0];
    if (!conceptItem) {
        Logger.log(`Failed to fetch concept name by subscription sku. Error: Subscription has no selected concept. Subscription sku: ${subscription.sku}`);
        return;
    }
    return selectConceptName(conceptItem);
};
function selectConceptName(concept) {
    const conceptName = getComponentContentById(concept.components, CRYSTALLIZE_IDS.SHAPE.DOCUMENT.CONCEPT.NAME);
    return conceptName?.text;
}
